import { Button, Colors, IcCashierSave, Tabs } from 'basic-ui-lib';
import styled from 'styled-components';
import MediaContent from '../MediaContent';
import { FormInstance } from 'antd';
import { FormValues } from '../ChannelForm';
import LinkContent from '../LinkContent';

interface PlaylistMediaProps {
  form?: FormInstance<FormValues>;
  idChannel?: string;
}
const PlaylistMedia = ({ form, idChannel }: PlaylistMediaProps) => {
  const items = [
    {
      label: 'Media',
      key: 'media',
      children: <MediaContent form={form} />,
    },
    {
      label: 'Links',
      key: 'links',
      children: <LinkContent />,
    },
  ];


  return (
    <Container>
      <Tabs items={items} />
      <FooterActions>
        <Button type_second lg prefix={<IcCashierSave fill={Colors.neutral.bg[1]} width={20} height={20}/>} className='styled-button' type='submit'>
          {
            idChannel ? 'Update' : 'Save'
          }
        </Button>
      </FooterActions>
    </Container>
  );
};

export default PlaylistMedia;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;

const FooterActions = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  gap: 16px;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);

  .styled-button {
    flex: 1;
  }
`;